<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AC6vr5/tc-custom/9781612004891.jpg?1721057612352" alt="This image is the cover for the book Big Guns, Casemate Short History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Big Guns, Casemate Short History
      </h1>
      <p class="bookDescription body article font2">
        <b>A concise, illustrated introduction to artillery from medieval times to the modern era.</b><br/>  <br/> Over seven centuries, the artillery piece has evolved from a status symbol to one of the most deadly weapons wielded by man. Using gunpowder weapons was initially something of a black art, but over time, gunnery became a science, a dependable method of breaching fortifications or overcoming an enemy on the battlefield.<br/>  <br/> By the nineteenth century, most European armies had artillery units manned with trained gunners; Napoleon, originally an artillery officer, then took the use of artillery to a new level. Over the following decades, rapid advances in gun technology paved the way for the devastatingly powerful heavy artillery that literally transformed the landscape during World War I. The use of rolling and box barrages shaped how armies fought on the front lines, and powerful naval guns dictated the outcome of battles at sea.<br/>  <br/> By World War II, the range of artillery had expanded to include self-propelled guns and powerful antitank and antiaircraft guns. In this informative introduction, historian Angus Konstam concisely explains how the development and evolving deployment of artillery led to big guns becoming the key to victory in two world wars and a potent force on the modern battlefield.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angus Konstam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?446acba5